import { useState, useEffect } from 'react';
import Api from './Api';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    const { http } = Api();
    const validateToken = () => {
      http.get('validate-token').then(response => {
        if (response.data.status_code === "MSG4") {

          setUserType(response.data.data.user.user_type);
          setIsAuthenticated(true);
          setIsImpersonating(response.data.data.impersonating || false);
          if(response.data.data.refresh_token){
            localStorage.setItem('refresh_token', response.data.data.refresh_token);
          }
          localStorage.setItem('username', response.data.data.user.name); 
          localStorage.setItem('usertype', response.data.data.user.user_type);
          localStorage.setItem('id', response.data.data.user.id);
          localStorage.setItem('collegeid', response.data.data.user.college_id);
          
          if (response.data.data.impersonating) {
            localStorage.setItem('impersonating', 'true');
          }
        } else {
          setIsAuthenticated(false);
          setUserType(false);
          setIsImpersonating(false);
          localStorage.removeItem("username");
          localStorage.removeItem('token');
          localStorage.clear();
        }
      })
      .catch(error => {
        console.error('Token validation failed:', error.response ? error.response.data.message : error.message);
        setIsAuthenticated(false); 
        setIsImpersonating(false);
      });
    };
    
    validateToken();
  }, []);

  return { isAuthenticated, userType, isImpersonating };
};

export default useAuth;